import '../../index.css';
import handoff from "../../Assets/images/FixedHandingBook.png"
import useWindowSize from '../../Globals/Helpers/useWindowSize';
import SearchBar from '../../Globals/CustomComponents/SearchBar';
import { useNavigate } from 'react-router-dom';

export default function Home() {
    const { width } = useWindowSize();
    const isMobile = width <= 768;
    const margins = isMobile 
        ? { marginTop: "-40px", marginBottom: "-30px"} 
        : { marginTop: "-72px", marginBottom: "-45px"}
    const styledImg = isMobile 
        ? {...margins, width: "90%", maxWidth: "400px"} 
        : {...margins, maxWidth: "625px", left: "327px"}
    const nav = useNavigate()

    const handleSearch = (value) => {
        if (!value?.trim()) return;
        
        // Navigate to listings page with search query
        nav(`/listings?search=${encodeURIComponent(value.trim())}`);
    };

    return (
        <div className="flex flex-wrap flex-col justify-center items-center bg-[#E6F0F9] mt-[10vh] md:mt-[17vh] w-full px-4 md:px-0">
            <h1 className="font-ubuntu font-normal text-[24px] md:text-[40px] leading-[30px] md:leading-[46px] text-center w-full md:w-[625px] h-auto md:h-[85px] self-center mx-[5px] -mt-[60px] md:-mt-[140px] relative z-[1] px-2">
                The easiest way to find and sell used textbooks on campus
            </h1>
            
            <div className="flex justify-center w-full">
                <img style={styledImg} src={handoff} alt="" className="w-full md:w-auto" />
            </div>
            
            <h1 className="font-ubuntu font-normal text-[24px] md:text-[40px] leading-[30px] md:leading-[46px] text-center w-full md:max-w-[625px] self-center mx-[5px] mt-[5px] mb-[10px]">
                Find a textbook
            </h1>
            
            <div className="w-full md:w-auto px-2 md:px-0">
                <SearchBar 
                    onSearch={handleSearch}
                    isMobile={isMobile}
                />
            </div>
            
            <h1 className="font-ubuntu font-normal text-[20px] md:text-[32px] text-center w-full md:max-w-[625px] self-center mt-[5px] mb-[20px] md:mb-[30px]">
                or
            </h1>
            
            <button 
                onClick={() => nav("/my-listings")}
                className="w-[240px] md:w-[323px] h-[50px] md:h-[70px] rounded-[10px] border-none bg-[#6B89FF] -mt-[10px] md:-mt-[20px] self-center cursor-pointer transition-colors duration-200 shadow-md hover:bg-[#5A75E6]"
            >
                <h1 className="font-ubuntu font-normal text-[20px] md:text-[32px] leading-[24px] md:leading-[37px] text-center text-white m-0 flex justify-center items-center">
                    Sell your textbook
                </h1>
            </button>
        </div>
    );
}
